export default {"src":"/_next/static/media/BRK.A.c32746c3.svg","height":18,"width":18};